import { useState } from 'react';
import {
  Button,
  Dropdown,
  Modal,
  Skeleton,
  Table,
  TablePaginationConfig,
  Tag,
  Typography,
} from 'antd';
import dayjs from 'dayjs';
import { MoreVertical } from 'lucide-react';
import { useMeetingById, useMeetingByStatus } from '../../hooks/useMeetings';
import UserManagementSkeleton from '../Skeleton/UserManagement';
import ScheduleMeeting from './ScheduleMeeting';
import { RequestedMeetingType } from '../../types/meeting';
import { useAppStore } from '../../store/appStore';

const RequestedMeeting = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMeetingId, setSelectedMeetingId] = useState<number>();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const profile = useAppStore((state) => state.profile);
  const userId = profile.user.id;

  const MeetingManager = profile?.user.role.roleName === 'Meeting Manager';

  // Fetch requested meetings with server-side pagination
  const {
    data: meetings,
    isLoading,
    error,
  } = useMeetingByStatus('FORWARDING', page, limit, userId);
  const data = meetings?.data || [];

  const { data: meetingData, isLoading: isMeetingDataLoaded } = useMeetingById(
    selectedMeetingId as number
  );

  console.log("data mkppp fjkjj",data)

  const scheduleMeeting = (id: number) => {
    setIsModalOpen(true);
    setSelectedMeetingId(id);
  };

  const columns = [
    { title: 'Title', dataIndex: 'title', key: 'title' },
    { title: 'Organization', dataIndex: 'organization', key: 'organization' },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date: string) => dayjs(date).format('DD-MM-YYYY'),
      sorter: (a: RequestedMeetingType, b: RequestedMeetingType) =>
        dayjs(a.date).unix() - dayjs(b.date).unix(),
    },
    // {
    //   title: 'Time',
    //   dataIndex: 'date',
    //   key: 'time',
    //   render: (date: string) => dayjs(date).format('hh:mm A'),
    //   sorter: (a: RequestedMeetingType, b: RequestedMeetingType) =>
    //     dayjs(a.date).unix() - dayjs(b.date).unix(),
    // },
    {
  title: 'Time',
  dataIndex: 'time',
  key: 'time',
  render: (time: string) => dayjs(time, "HH:mm").format("hh:mm A"),
}
,
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      // render: (status: string) => <Tag color="magenta">{status}</Tag>,
      render: (status: string) => {
  const displayStatus = status === 'FORWARDING' ? 'In Planning' : status;
  return <Tag color="magenta">{displayStatus}</Tag>;
},

    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'right' as const,
      render: (_: unknown, record: RequestedMeetingType) => (
        <Dropdown
          menu={{
            items: [
              {
                key: 'schedule',
                label: MeetingManager ? 'Add Users' : 'View',
                onClick: () => scheduleMeeting(record.id),
              },
            ],
          }}
          trigger={['click']}
        >
          <Button type="text" icon={<MoreVertical size={16} />} />
        </Dropdown>
      ),
    },
  ];

  const handleTableChange = (pagination: TablePaginationConfig) => {
    if (pagination.current) setPage(pagination.current);
    if (pagination.pageSize) setLimit(pagination.pageSize);
  };

  if (isLoading) return <UserManagementSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={{
          current: meetings?.pagination.page || page,
          pageSize: meetings?.pagination.limit || limit,
          total: meetings?.pagination.total || 0,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} meetings`,
        }}
        onChange={handleTableChange}
        className="overflow-x-auto"
      />

      <Modal
        title="Details for Status: Requested"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={800}
      >
        {!isMeetingDataLoaded ? (
          meetingData ? (
            <ScheduleMeeting
              closeStatusModal={setIsModalOpen}
              meetingData={meetingData}
              onUpdate={async (values, id) => {
                console.log(values, id);
              }}
            />
          ) : (
            <Typography.Text>No meeting data available</Typography.Text>
          )
        ) : (
          <Skeleton active />
        )}
      </Modal>
    </div>
  );
};

export default RequestedMeeting;
